/* Torpion – Produktseite: Galerie, Varianten-Bild, URL, Sticky-Kaufleiste, Sub-Nav */
(function(){
  "use strict";
  var root = document.querySelector("[data-pdp]");
  if (!root) return;

  /* ---------- Galerie ---------- */
  var pg = root.querySelector("[data-pg]");
  var track = pg && pg.querySelector(".pg-track");
  var slides = track ? [].slice.call(track.children) : [];
  var thumbs = [].slice.call(root.querySelectorAll("[data-pg-thumb]"));
  var count = pg && pg.querySelector(".pg-count");
  var cur = 0;
  function go(i){
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: "smooth" });
  }
  function mark(i){
    cur = i;
    if (count) count.textContent = (i + 1) + " / " + slides.length;
    thumbs.forEach(function(t, k){ t.classList.toggle("is-active", k === i); });
    var t = thumbs[i];
    if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: "smooth" }); }
    slides.forEach(function(s, k){ var v = s.querySelector("video"); if (v && k !== i) v.pause(); });
  }
  if (track) {
    var raf;
    track.addEventListener("scroll", function(){
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function(){ var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== cur) mark(i); });
    }, { passive: true });
    var prev = pg.querySelector("[data-pg-prev]"), next = pg.querySelector("[data-pg-next]");
    prev && prev.addEventListener("click", function(){ go(cur - 1); });
    next && next.addEventListener("click", function(){ go(cur + 1); });
    thumbs.forEach(function(t, k){ t.addEventListener("click", function(){ go(k); }); });
    pg.addEventListener("keydown", function(e){ if (e.key === "ArrowRight") go(cur + 1); if (e.key === "ArrowLeft") go(cur - 1); });
    mark(0);
  }

  /* ---------- Variante: Bild, URL, Lagerstatus ---------- */
  var form = root.querySelector("[data-product-form]");
  var variants = [];
  try { variants = JSON.parse(form.querySelector("[data-variants]").textContent); } catch(e) {}
  var idInput = form && form.querySelector("[data-variant-id]");
  var stock = root.querySelector("[data-stock]");
  function syncVariant(){
    if (!idInput) return;
    var id = parseInt(idInput.value, 10);
    var v = variants.filter(function(x){ return x.id === id; })[0];
    if (!v) return;
    if (v.featured_media_id) {
      for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute("data-media-id") == v.featured_media_id) { go(k); break; } }
    }
    try { var u = new URL(window.location.href); u.searchParams.set("variant", id); history.replaceState(null, "", u.toString()); } catch(e) {}
    if (stock) {
      stock.classList.toggle("out", !v.available);
      var label = stock.querySelector("[data-stock-label]");
      if (label) label.textContent = v.available ? stock.getAttribute("data-in") : stock.getAttribute("data-out");
    }
    syncBar();
  }
  if (form) {
    form.querySelectorAll("[data-opt]").forEach(function(i){ i.addEventListener("change", function(){ setTimeout(syncVariant, 0); }); });
  }

  /* ---------- Sticky-Kaufleiste ---------- */
  var bar = document.querySelector("[data-pdp-bar]");
  var addBtn = form && form.querySelector("[data-add]");
  var priceNow = root.querySelector("[data-price-now]");
  function syncBar(){
    if (!bar) return;
    var bp = bar.querySelector("[data-bar-price]"), bb = bar.querySelector("[data-bar-add]");
    if (bp && priceNow) bp.textContent = priceNow.textContent;
    if (bb && addBtn) { bb.disabled = addBtn.disabled; bb.textContent = addBtn.disabled ? addBtn.textContent.trim() : addBtn.getAttribute("data-label-add"); }
  }
  if (bar && addBtn && "IntersectionObserver" in window) {
    new IntersectionObserver(function(es){
      var e = es[0];
      bar.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(addBtn);
    var bb = bar.querySelector("[data-bar-add]");
    bb && bb.addEventListener("click", function(){
      if (form.requestSubmit) form.requestSubmit(); else addBtn.click();
    });
    if ("MutationObserver" in window) {
      new MutationObserver(syncBar).observe(addBtn, { attributes: true, childList: true, characterData: true, subtree: true });
    }
    syncBar();
  }

  /* ---------- Sub-Navigation aktiv markieren ---------- */
  var links = [].slice.call(document.querySelectorAll(".pdp-nav a"));
  if (links.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting) {
          links.forEach(function(a){ a.classList.toggle("is-active", a.getAttribute("href") === "#" + e.target.id); });
        }
      });
    }, { rootMargin: "-40% 0px -55% 0px" });
    links.forEach(function(a){ var s = document.querySelector(a.getAttribute("href")); if (s) io.observe(s); });
  }
})();
